/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Eventreport_Pain_Item61Inputs */

const ja_playdata_eventreport_pain_item61 = /** @type {(inputs: Playdata_Eventreport_Pain_Item61Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各eスポーツ大会の累計視聴時間を把握したい`)
};

const en_playdata_eventreport_pain_item61 = /** @type {(inputs: Playdata_Eventreport_Pain_Item61Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I want to know the cumulative watch time of each esports tournament`)
};

/**
* | output |
* | --- |
* | "I want to know the cumulative watch time of each esports tournament" |
*
* @param {Playdata_Eventreport_Pain_Item61Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_eventreport_pain_item61 = /** @type {((inputs?: Playdata_Eventreport_Pain_Item61Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Eventreport_Pain_Item61Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_eventreport_pain_item61(inputs)
	return en_playdata_eventreport_pain_item61(inputs)
});
export { playdata_eventreport_pain_item61 as "playdata_eventReport_pain_item6" }